import { QueryKey } from "@tanstack/react-query";

export const availabilityAsMemberQueryKeys = {
  all: () => ["availabilityAsMember"] as QueryKey,
  hostCalculateAvailability: (
    filter: Readonly<{
      appointableId?: number;
      dateFrom?: string;
      dateTo?: string;
      hostsIdList?: string[];
    }>,
  ) =>
    [
      ...availabilityAsMemberQueryKeys.all(),
      "host",
      "calculate",
      filter,
    ] as QueryKey,
  facilityCalculateAvailability: (
    filter?: Readonly<{
      appointableId?: number;
      dateFrom?: string;
      dateTo?: string;
      hostsIdList?: string[];
      facilityIdList?: number[];
    }>,
  ) => {
    if (filter) {
      return [
        ...availabilityAsMemberQueryKeys.all(),
        "facility",
        "calculate",
        filter,
      ] as QueryKey;
    }

    return [
      ...availabilityAsMemberQueryKeys.all(),
      "facility",
      "calculate",
    ] as QueryKey;
  },

  hostCalculateAvailabilityNew: (filter: any) =>
    [
      ...availabilityAsMemberQueryKeys.all(),
      "host",
      "calculateNew",
      filter,
    ] as QueryKey,
  facilityCalculateAvailabilityNew: (filter?: any) => {
    if (filter) {
      return [
        ...availabilityAsMemberQueryKeys.all(),
        "facility",
        "calculateNew",
        filter,
      ] as QueryKey;
    }

    return [
      ...availabilityAsMemberQueryKeys.all(),
      "facility",
      "calculate",
    ] as QueryKey;
  },
};
